<template>
  <img
    v-if="(desktop && desktop.file && !isMobile) || (desktop && desktop.file && (!mobile || !mobile.file) && isMobile)"
    class="responsive-image desktop"
    :src="resourceUrl + desktop.file.path"
    alt
  />
  <img
    v-else-if="mobile && mobile.file && isMobile"
    class="responsive-image mobile"
    :src="resourceUrl + mobile.file.path"
    alt
  />
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "responsive-image",
  props: {
    desktop: {
      required: true
    },
    mobile: {
      default: null
    }
  },
  data() {
    return {
      resourceUrl: process.env.VUE_APP_RESOURCES,
    };
  },
  computed: {
    ...mapGetters({
      isMobile: "getIsMobile"
    })
  }
};
</script>
<style lang="scss" scoped>
</style>